/* Mirelyae — fiche correcteur : offre 1 / 1+1 OFFERT (+ pinceau offert), ajout au panier Horizon. */
import { CartLinesUpdateEvent } from '@shopify/events';

class CcOffre extends HTMLElement {
  connectedCallback() {
    this.cartes = [...this.querySelectorAll('[data-carte]')];
    this.btn = this.querySelector('[data-ajout]');
    this.err = this.querySelector('[data-err]');
    this.addEventListener('change', (e) => {
      if (e.target.matches('[data-palier]')) this.update();
      if (e.target.matches('[data-teinte]')) {
        const img = e.target.closest('.cc-ligne').querySelector('.cc-ligne__img'), src = e.target.selectedOptions[0]?.dataset.img;
        if (img && src) { img.src = src; img.removeAttribute('srcset'); }
      }
    });
    this.btn?.addEventListener('click', () => this.add());
    this.update();
    this.chrono();
  }
  chrono() {
    const el = this.querySelector('[data-chrono]');
    if (!el) return;
    const duree = (parseInt(this.dataset.minutes, 10) || 5) * 60000, cle = 'mir-cc-fin';
    let fin = 0;
    try { fin = parseInt(sessionStorage.getItem(cle), 10) || 0; } catch {}
    const tick = () => {
      let reste = fin - Date.now();
      if (reste <= 0) { fin = Date.now() + duree; reste = duree; try { sessionStorage.setItem(cle, String(fin)); } catch {} }
      const t = Math.ceil(reste / 1000), m = Math.floor(t / 60), sec = t % 60;
      el.textContent = `${String(m).padStart(2, '0')}:${String(sec).padStart(2, '0')}`;
    };
    tick();
    clearInterval(this._t); this._t = setInterval(tick, 1000);
  }
  disconnectedCallback() { clearInterval(this._t); }
  get carte() { return this.cartes.find((c) => c.querySelector('[data-palier]').checked) || this.cartes[0]; }
  update() {
    const on = this.carte;
    this.cartes.forEach((c) => c.classList.toggle('is-on', c === on));
    const tot = this.querySelector('[data-total]'), prix = on?.querySelector('[data-palier]')?.dataset.prix;
    if (tot && prix) tot.textContent = prix;
    if (this.err) this.err.hidden = true;
  }
  lignes() {
    const c = this.carte, qte = new Map();
    c.querySelectorAll('[data-teinte]').forEach((s) => qte.set(s.value, (qte.get(s.value) || 0) + 1));
    const items = [...qte].map(([id, quantity]) => ({ id: parseInt(id, 10), quantity }));
    const cadeau = c.querySelector('[data-cadeau]');
    if (cadeau) items.push({ id: parseInt(cadeau.dataset.cadeau, 10), quantity: 1 });
    return items;
  }
  async add() {
    const items = this.lignes();
    const root = window.Shopify?.routes?.root || '/';
    this.btn.classList.add('mir-chargement');
    const sections = [...document.querySelectorAll('cart-items-component')].map((c) => c.dataset.sectionId).filter(Boolean);
    const deferred = CartLinesUpdateEvent.createPromise();
    this.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'product', lines: items.map((x) => ({ merchandiseId: String(x.id), quantity: x.quantity })), promise: deferred.promise }));
    try {
      const res = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items, sections: sections.join(',') }) });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Erreur');
      const cart = await (await fetch(`${root}cart.js`)).json();
      deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, sections: data.sections, didError: false, source: 'mir-cc', itemCount: items.reduce((a, x) => a + x.quantity, 0) } });
    } catch (e) {
      deferred.reject(e);
      this.err.textContent = e.message; this.err.hidden = false;
    } finally {
      this.btn.classList.remove('mir-chargement');
    }
  }
}
if (!customElements.get('cc-offre')) customElements.define('cc-offre', CcOffre);
